import Vue from 'vue';
import './layout.scss';
import layoutBase from '../layout-base';
import mstb from '../../modules/MSTB/mstb';
import mvtu from '../../modules/MVTU/mvtu';
import videoPlayer from '../../common/components/video-player/video-player.vue';
import VueYouTubeEmbed from 'vue-youtube-embed';

Vue.use(VueYouTubeEmbed);
new Vue({ extends: layoutBase, components: { mstb, mvtu, videoPlayer } }).$mount('[data-layout-id="ATER-app"]');
